import { Typography, Button } from "@material-ui/core";
import '../styles/Globales.scss';
import "../styles/SolicitarPortabilidad.scss";
import appStore from '../stores/AppStore';
import { observer } from "mobx-react";


import React, { Component } from 'react'
import BtnResumen from "./utils/BtnResumen";

const component = observer(class ResumenPortabilidadComponent extends Component {

    onDeleteItem = (producto) => {
        if (this.props.onDeleteItem) {
            this.props.onDeleteItem(producto);
        }
    }

    onCerrarClick = () => {
        if (this.props.onCerrar) {
            this.props.onCerrar();
        }
    }

    onCompletarClick = () => {
        if (this.props.onCompletar) {
            this.props.onCompletar();
        }
    }

    render() {
        const disableContinuar = (appStore.solicitarNuevaPortalidadStore.bolsaProductos.length === 0);
        return (
            <div className="bloqueoBolsaProductos">
                <Typography className="tituloBolsa">Bolsa de Portabilidad</Typography>
                <Typography className="tituloStepSolicitud">Estos son los productos que haz seleccionado para portar a <strong>Banco Ripley</strong></Typography>
                <div>
                    {appStore.solicitarNuevaPortalidadStore.bolsaProductos.map((item, index) => {
                        return <BtnResumen key={index} producto={item} onDelete={this.onDeleteItem} />
                    })}
                </div>
                <div className="botones">
                    <Button
                        color="primary"
                        id="btnVolver"
                        className="btnRipleyAmarillo"
                        fullWidth={true}
                        onClick={this.onCerrarClick}
                        disabled={false}>
                        Cerrar
                        </Button>
                    <Button
                        color="primary"
                        id="btnVolver"
                        className="btnRipley"
                        fullWidth={true}
                        disabled={disableContinuar}
                        onClick={this.onCompletarClick}>
                        Continuar
                </Button>
                </div>
            </div>

        )
    }
});

export default component;
